import {
  browserFastApiClient,
  requireFastApiAccessToken,
} from "@/core/fastapi";
import {
  updateSituationConfigApiService,
  type UpdateSituationConfigRequest,
} from "@/generated/fastapi";

export async function updateSituationConfig(
  accessToken: string | null | undefined,
  request: UpdateSituationConfigRequest,
) {
  const response = await updateSituationConfigApiService({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(
      `Failed to update situation configuration (${response.status})`,
    );
  }

  return response.data;
}
